import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_cl0th8ix44: FaireBrandEntity = {
  token: "b_cl0th8ix44",
  type: "brand",
  name: "Orglamix",
  avatarUrl:
    "https://cdn.faire.com/fastly/fc20726b7c8498845069a657157c790cb9f18b79fb90cf6c34a709f1cd7b888b.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/e851b8479312675b84b59269a87ddb279fdfe077b26b9463828e27465d5be4e6.png",
  logoUrl:
    "https://cdn.faire.com/fastly/fc20726b7c8498845069a657157c790cb9f18b79fb90cf6c34a709f1cd7b888b.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/e851b8479312675b84b59269a87ddb279fdfe077b26b9463828e27465d5be4e6.png",
  location: "Glenview, IL, USA",
  minimumOrderDollars: 50,
  rating: 4.9,
  reviewCount: 348,
  isTopShop: true,
  isInsider: true,
  description:
    "Clean consciously crafted cosmetics, organic skincare, essential oils, sage, coconut candles + crystals, handcrafted in small batches with love on shores of Lake Michigan.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:45:31.919Z",
    importedBy: "entity-db-cli",
  },
};
